import { Instance } from 'mobx-state-tree';
import { RouteArrivedAtStopDtoModelBase } from './RouteArrivedAtStopDtoModel.base';

/* The TypeScript type of an instance of RouteArrivedAtStopDtoModel */
export interface RouteArrivedAtStopDtoModelType extends Instance<typeof RouteArrivedAtStopDtoModel.Type> {}

/* A graphql query fragment builders for RouteArrivedAtStopDtoModel */
export { selectFromRouteArrivedAtStopDto, routeArrivedAtStopDtoModelPrimitives, RouteArrivedAtStopDtoModelSelector } from './RouteArrivedAtStopDtoModel.base';

/**
 * RouteArrivedAtStopDtoModel
 *
 * Completed ArriveAtStop event
 */
export const RouteArrivedAtStopDtoModel = RouteArrivedAtStopDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
